module.exports = __webpack_public_path__ + "img/slotmachine_normal_fg.86a9c281.png";